<template>
  <svg viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg" :width="width" :height="height">
    <path
      d="m46.7845 12.6136h-21.569c-6.9598 0-12.6019 5.6421-12.6019 12.6019v21.5689c0 6.9598 5.6421 12.6019 12.6019 12.6019h21.5689c6.9598 0 12.6019-5.6421 12.6019-12.6019v-21.5689c.0001-6.9598-5.642-12.6019-12.6018-12.6019z"
      :fill="fill"
      :stroke="strokeColor"
      stroke-miterlimit="10"
      stroke-width="2"
    />
    <circle
      cx="36"
      cy="36"
      :fill="fill"
      r="11.29"
      :stroke="strokeColor"
      stroke-miterlimit="10"
      :stroke-width="strokeWidth"
    />
  </svg>
</template>

<script>
export default {
  name: "Instagram",
  props: {
    xmlns: {
      type: String,
      default: "http://www.w3.org/2000/svg",
    },
    viewBox: {
      type: String,
      default: "0 0 72 72",
    },
    width: {
      type: String,
      default: "24",
    },
    height: {
      type: String,
      default: "24",
    },
    fill: {
      type: String,
      default: "none",
    },
    strokeColor: {
      type: String,
      default: "#0078c1",
    },
    strokeWidth: {
      type: String,
      default: "2",
    },
  },
};
</script>
